import React from "react";

import { adminRoles } from "enums";

import { Drawer, Typography } from "components";

type AdminRolesDrawerProps = {
  visible: boolean;
  onClose: () => void;
};

type AdminRole = {
  role: string;
  label?: string;
  allowAccess?: string[];
  disallowAccess?: string[];
};

/**
 * Lists every admin role and the pages it is restricted to. A role using `allowAccess` (a guest
 * login) shows the only pages it can reach; every other role shows the pages it is blocked from.
 */
export const AdminRolesDrawer = ({ visible, onClose }: AdminRolesDrawerProps) => (
  <Drawer title="Admin roles" visible={visible} onClose={onClose}>
    <Typography variant="paragraph-m">
      Pages listed here are <b>not</b> available to the specified admin role, unless the role is a guest login, in which case they are the <b>only</b> pages
      available to it.
    </Typography>
    {adminRoles.map((role: AdminRole) => (
      <div key={role.role}>
        <br />
        <b>{(role.label ?? role.role).toUpperCase()}</b>
        <br />
        {(role.allowAccess ?? role.disallowAccess ?? []).map((route: string) => (
          <React.Fragment key={route}>
            {route}
            <br />
          </React.Fragment>
        ))}
      </div>
    ))}
  </Drawer>
);
